import type {Currency, FieldTypeId} from 'src/typings';

// States
export const SUTOR_REFERENCE_STATES = {
    NEW: 'new',
    DONE: 'done',
    IN_PROGRESS: 'inprogress'
} as const;

export const SUTOR_REPORT_STATES = {
    CONFIRMED: 'confirmed',
    IN_PROGRESS: 'in_progress',
    TO_CONFIRM: 'to_confirm',
    RETURNED: 'returned'
} as const;

export const SUTOR_REPORT_TYPES = {
    WORK: 'work',
    MEDICAL_LEAVE: 'medical_leave',
    VACATION: 'vaca',
    SICK_LEAVE: 'ill',
    OCR: 'ocr',
    PARAGRAPH: 'para',
    COMPENSATION: 'compens',
    UNPAID: 'unpaid',
    UNEXCUSED: 'unexcused',
    PATERNITY: 'paternity',
    ON_CALL_DUTY: 'oncall',
    MATERNITY: 'maternity',
    EMPLOYER_OBSTACLES: 'problem',
    EVENTS_FOR_CHILDREN: 'events'
} as const;

export const SUTOR_MONTH_ATTENDANCE_STATES = {
    IN_PROGRESS: 'inprogress',
    TO_CHECK: 'tocheck',
    RETURNED: 'returned',
    CHECKED: 'checked',
    CLOSED: 'closed',
    RETURNED_CHECKED: 'returned_checked',
    TOCHECK_FIXED: 'tocheck_fixed',
    CHECKED_FIXED: 'checked_fixed'
};

export const SUTOR_MONTH_ATTENDANCE_STATES_NAMES: Record<keyof typeof SUTOR_MONTH_ATTENDANCE_STATES, string> = {
    IN_PROGRESS: 'Rozpracováno',
    TO_CHECK: 'Ke kontrole',
    RETURNED: 'Vráceno',
    CHECKED: 'Zkontrolováno',
    CLOSED: 'Uzavřeno',
    RETURNED_CHECKED: 'Vráceno po kontrole',
    TOCHECK_FIXED: 'Ke kontrole po opravě',
    CHECKED_FIXED: 'Zkontrolováno po opravě'
};

export const SUTOR_MONTH_ATTENDANCE_PAYMENT_STATE = {
    NOTHING: 'nothing',
    D: 'd',
    FA: 'fa',
    OF: 'of',
    OF_IN_BONUS: 'of_in_bonus'
};

// Page settings
export const SUTOR_REPORTS_PROCESSING_PAGE = {
    fond: 90,
    fondMaterial: 92,
    fondProgrammers: 95 // Systemist programmers
};

export const SUTOR_REPORTS_APPROVING_PAGE = {
    fond: 91,
    reportRefreshEvent: 'report-approving-refresh-event'
};

export const SUTOR_REPORTS_OPTIMISATION_PAGE = {
    fond: 102,

    reportServerTemplateOverallOverview: 'predavaci-protokol-aktualni'
};

export const SUTOR_LOGBOOK_PAIRING_PAGE = {
    logbooksFond: 104,
    logbookReferenceField: 'd3002.main' as FieldTypeId,
    reportServerTemplateMD: 'montazni-denik-aktualni'
};

export const CZK_CURRENCY: Currency = {
    id: 'CZK',
    text: 'Kč'
}